module.exports = __webpack_public_path__ + "img/销售明细2.c79beb80.svg";